import React, {useState} from 'react';
import TextInput from "../../../../Common/components/text-input";;

function Tab1({tab, onValidate}) {
    const [submitAttempted, setSubmitAttempted] = useState(false)

    const handleSubmit = _ => {
        onValidate();
        setSubmitAttempted(true)
    }

    return (
        <div className="form mt-0 mt-lg-10">
            <div
                className="pb-5"
                data-wizard-type="step-content"
                data-wizard-state={tab === 1 ? "current" : ""}
            >
                <div className="mb-10 h3 font-weight-bold text-dark">Bank Details</div>
                <div className="row">
                    <TextInput
                        label="Name*"
                        name="bankName"
                        type="text"
                        shouldShowError={submitAttempted}
                    />
                </div>
                <div className="row">
                    <TextInput
                        label="Currency*"
                        name="currency"
                        type="text"
                        shouldShowError={submitAttempted}
                    />
                    <TextInput
                        label="Country*"
                        name="country"
                        type="text"
                        shouldShowError={submitAttempted}
                    />
                </div>
                <div className="row">
                    <TextInput
                        label="Monnify Code"
                        name="monnifyCode"
                        type="text"
                        shouldShowError={submitAttempted}
                    />
                    <TextInput
                        label="Paystack Code"
                        name="paystackCode"
                        type="text"
                        shouldShowError={submitAttempted}
                    />
                    <TextInput
                        label="Flutterwave Code"
                        name="flutterwaveCode"
                        type="text"
                        shouldShowError={submitAttempted}
                    />
                </div>

                {/* <!--begin: Wizard Actions--> */}
                <div className="text-right border-top mt-5 pt-10">
                    <button
                        onClick={handleSubmit}
                        type="button"
                        className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4"
                    >
                        Next
                    </button>
                </div>
                {/* <!--end: Wizard Actions--> */}
            </div>
        </div>
    );
}

export default Tab1;